/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import Alert from './Alert';
import L from './Lang';

export default class E404 extends React.Component {

    render() {
        return (<div className="container-fluid"><h1><L>Error 404</L></h1><Alert type="danger" message="Page not found." icon="ExclamationTriangle" /></div >);
    }
}